import { ERP_ALL_BANKS_DETAILS, ERP_ALL_BANKS_DETAILS_ERROR, ERP_FIN_SUM_TOTAL_BALANCE_AMOUNT_BY_LOCATION, ERP_FIN_SUM_TOTAL_BILL_AMOUNT_BY_LOCATION, ERP_FIN_SUM_TOTAL_CREDITED_AMOUNT_BY_LOCATION, ERP_HMS_MASTER_LOCATION_DETAILS, ERP_INVOICE_LIST, ERP_OUTSTANDING_BILLS, ERP_PATIENT_DETAIL, ERP_PAYMENT_LIST, ERP_PRODUCT_LIST, ERP_PRODUCT_LIST_ERROR, ERP_PRODUCTS_LIST_ERROR, ERP_SERVICE_LIST, ERP_TABLE_NEW_INVOICE_ITEMS, ERP_VISIT_DETAIL } from "../constants/erpConstants";

const erpDetailsState = {
  patient: {},
  visit: {},
  services: [],
  invoices: [],
  payments: [],
  erpProductsList: [],
  erpBanksInfo: [],
  erpNewInvoiceItems: [],
  error: "",
  erpProductsListError: "",
  masterLocationDetails: "",
  outstandingBillsListing: "",
  ERP_ALL_BANKS_DETAILS_ERROR: "",
  loading: false,
};

function setERPDetailsState(state = erpDetailsState, action) {
  switch (action.type) {
    case ERP_PATIENT_DETAIL:
      console.log("ERP_PATIENT_DETAIL", action.payload);
      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: null,
        patient: action.payload,
      });
    case ERP_VISIT_DETAIL:
      console.log("ERP_VISIT_DETAIL", action.payload);
      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: null,
        visit: action.payload,
      });
    case ERP_SERVICE_LIST:
      console.log("ERP_SERVICE_LIST", action.payload);
      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: null,
        services: action.payload,
      });
    case ERP_INVOICE_LIST:
      console.log("ERP_INVOICE_LIST", action.payload);
      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: null,
        invoices: action.payload,
      });
    case ERP_PAYMENT_LIST:
      console.log("ERP_INVOICE_LIST", action.payload);
      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: null,
        payments: action.payload,
      });
    //   case ERP_PAYMENTS_LIST:
    //     console.log("ERP_INVOICE_LIST", action.payload);
    //     return Object.assign({}, state, {
    //       invoices: action.payload,
    //     });
    case ERP_PRODUCT_LIST:
      console.log("ERP_PRODUCT_LIST", action.payload);
      return {
        ...state,
        erpProductsList: action.payload,
        erpProductsListError: null,
      };
    case ERP_PRODUCT_LIST_ERROR:
      console.log("ERP_PRODUCT_LIST_ERROR", action.payload);
      return {
        ...state,
        erpProductsListError: action.payload,
      };
    case ERP_FIN_SUM_TOTAL_CREDITED_AMOUNT_BY_LOCATION:
      console.log("ERP_FIN_SUM_TOTAL_CREDITED_AMOUNT_BY_LOCATION", action.payload);
      return {
        ...state,
        ERP_FIN_SUM_TOTAL_CREDITED_AMOUNT_BY_LOCATION: action.payload,
      };
    case ERP_FIN_SUM_TOTAL_BILL_AMOUNT_BY_LOCATION:
      console.log("ERP_FIN_SUM_TOTAL_BILL_AMOUNT_BY_LOCATION", action.payload);
      return {
        ...state,
        ERP_FIN_SUM_TOTAL_BILL_AMOUNT_BY_LOCATION: action.payload,
      };
    case ERP_FIN_SUM_TOTAL_BALANCE_AMOUNT_BY_LOCATION:
      console.log("ERP_FIN_SUM_TOTAL_BALANCE_AMOUNT_BY_LOCATION", action.payload);
      return {
        ...state,
        ERP_FIN_SUM_TOTAL_BALANCE_AMOUNT_BY_LOCATION: action.payload,
      };
    case ERP_ALL_BANKS_DETAILS:
      console.log("ERP_ALL_BANKS_DETAILS", action.payload);
      return {
        ...state,
        erpBanksInfo: action.payload,
      };
      case ERP_ALL_BANKS_DETAILS_ERROR:
        console.log("ERP_ALL_BANKS_DETAILS_ERROR", action.payload);
        return {
          ...state,
          ERP_ALL_BANKS_DETAILS_ERROR: action.payload,
        };
        case ERP_TABLE_NEW_INVOICE_ITEMS:
        console.log("ERP_TABLE_NEW_INVOICE_ITEMS", action.payload);
        return {
          ...state,
          erpNewInvoiceItems: action.payload,
        };
        case ERP_HMS_MASTER_LOCATION_DETAILS:
        console.log("ERP_TABLE_NEW_INVOICE_ITEMS", action.payload);
        return {
          ...state,
          masterLocationDetails: action.payload,
        };
        case ERP_OUTSTANDING_BILLS:
        console.log("ERP_TABLE_NEW_INVOICE_ITEMS", action.payload);
        return {
          ...state,
          outstandingBillsListing: action.payload,
        };

    default:
      return state;
  }
}

export default setERPDetailsState;
